import * as React from 'react';
import { cn } from '@/shared/lib/cn';

export interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  error?: string;
  icon?: React.ReactNode;
}

const Input = React.forwardRef<HTMLInputElement, InputProps>(
  ({ className, type, error, icon, ...props }, ref) => {
    const baseClasses = cn(
      'file:text-foreground placeholder:text-muted-foreground bg-input-background  selection:text-primary-foreground dark:bg-input/30',
      'flex w-full min-w-0 border px-3 py-1 text-base  transition-[color,box-shadow,border-color] outline-none',
      'file:inline-flex file:h-7 file:border-0 file:bg-transparent file:text-sm file:font-medium',
      'disabled:pointer-events-none disabled:cursor-not-allowed disabled:opacity-50',
      'md:text-sm focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px]',
      'h-11 rounded-lg',
      // Validation states
      error
        ? 'border-red-500 focus-visible:border-red-500 focus-visible:ring-red-500/20'
        : 'border-gray-300 aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive',
      icon && 'pl-10',
      className
    );

    if (icon) {
      return (
        <div className="relative">
          <div className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-gray-400">
            {icon}
          </div>
          <input
            type={type}
            data-radix-input
            data-slot="input"
            aria-invalid={error ? 'true' : undefined}
            className={baseClasses}
            ref={ref}
            {...props}
          />
        </div>
      );
    }

    return (
      <input
        type={type}
        data-radix-input
        data-slot="input"
        aria-invalid={error ? 'true' : undefined}
        className={baseClasses}
        ref={ref}
        {...props}
      />
    );
  }
);

Input.displayName = 'Input';

export { Input };
